export var ANTI_DOPING_LINK = [
  {
    label: "Обучение",
    link: "https://rusada.triagonal.net/",
  },
  {
    label: "Проверить лекарство",
    link: "https://list.rusada.ru/",
  },
];
